/* unplugin-vue-components disabled */import script from "./InvoicingDishesView.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoicingDishesView.vue?vue&type=script&setup=true&lang=js"

import "./InvoicingDishesView.vue?vue&type=style&index=0&id=247ab9e2&lang=scss"

const __exports__ = script;

export default __exports__